<script>
import { mapState } from 'vuex';
import Layout from '@layouts/main';
import JobForm from '@views/jobs/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';
import cloneDeep from 'lodash.clonedeep';
import '@src/plugins/websockets';

export default {
  name: 'JobEdit',
  components: {
    Layout,
    JobForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    job: {
      type: Object,
      required: true,
      default: null,
    },
  },
  page() {
    return {
      title: `${this.$t('titles.edit_job')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.jobs'),
          to: { name: 'jobs.index' },
        },
        {
          text: `${this.$t('titles.edit_job')} #${this.$route.params.id}`,
          active: true,
        },
      ],
      jobLocal: {
        id: null,
        editing_by: null,
      },
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    editable() {
      return typeof this.jobLocal === 'undefined' ? false : this.jobLocal.editing_by == null ? false : this.jobLocal.editing_by.id === this.currentUser.id;
    },
  },
  mounted() {
    this.jobLocal = cloneDeep(this.job);

    // if job is locked, wait for the edit lock
    this.$echo.channel(`job-editing-${this.jobLocal.id}`).listen('JobEditingEvent', (e) => {
      if (e.editing_by == null && this.entityChanged) {
        this.$refs.jobForm.submit(this.update);
      }
      this.job.editing_by = e.editing_by;
      this.jobLocal.editing_by = e.editing_by;
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.handleBeforeUnload();
  },
  methods: {
    handleBeforeUnload() {
      if (this.editable) {
        this.$http.post(`admin/jobs/${this.job.id}/finish-editing`);
      }
    },
    takeOverEditing() {
      window.location.reload();
    },
    update(job) {
      this.jobLocal = cloneDeep(job);
      this.$nextTick(() => {
        this.setUnchanged();
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div v-if="!editable" class="block-container">
      <div class="editing-by">
        <b-card
          bg-variant="light"
          header-bg-variant="dark"
          header-text-variant="white"
          :header="$t('infos.currently_editing')"
          class="text-center shadow rounded"
        >
          <div v-if="jobLocal.editing_by !== null">
            <b-avatar v-if="job.editing_by.avatar" :src="job.editing_by.avatar.small"></b-avatar>
            <b-avatar v-else src="@assets/images/none.png"></b-avatar>
            <p
              ><small>{{ job.editing_by.name }}</small></p
            >
          </div>
          <div v-else>
            <b-btn variant="primary" @click="takeOverEditing">{{ $t('actions.take_over_editing') }}</b-btn>
          </div>
        </b-card>
      </div>
    </div>
    <b-breadcrumb :items="breadcrumbItems" />

    <JobForm ref="jobForm" :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
  </Layout>
</template>
<style scoped>
.block-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 101;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
}

.block-container .editing-by {
  display: inline-block;
  position: absolute;
  top: 20%;
  z-index: 102;
  text-align: center;
}
</style>
